import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2NestedEmptyTextSx = {
  fontSize: '15px',
  fontWeight: 400,
} satisfies SxProps<Theme>;
